import { render, staticRenderFns } from "./UserEdit.vue?vue&type=template&id=37a06d06&"
import script from "./UserEdit.vue?vue&type=script&lang=js&"
export * from "./UserEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports